<template>
  <div class="content">
    <home-slider />
    <finder-form />
    <home-discover />
    <room-highlighted/>
    <business-slider/>
    <home-blog/>
    <homeTexts/>
  </div>
</template>

<script>

import homeSlider from './home-slider';
import finderForm from './finder-form';
import roomHighlighted from './room-highlighted';
import homeDiscover from './home-discover';
import homeDiscounts from './home-discounts';
import businessSlider from './home-promos';
import homeBlog from './home-blog';
import homeTexts from './home-texts';
import { setBodyHome } from '../../helpers/body-class.helper';

export default {
  name: 'Home',
  props: {
    open: {
      type: String,
      default: 'none'
    }
  },
  components: {
    homeSlider,
    finderForm,
    roomHighlighted,
    homeDiscover,
    homeDiscounts,
    businessSlider,
    homeBlog,
    homeTexts,
  },
  async mounted() {
    setBodyHome();
    if (this.$route.name === 'homeCgv') {
      this.$store.dispatch('legalModal/fetch');
      this.$store.commit('legalModal/SET_TAB', 1);
      this.$store.commit('legalModal/OPEN_MODAL');
    } else if (this.$route.name === 'homeLegalNotice') {
      this.$store.dispatch('legalModal/fetch');
      this.$store.commit('legalModal/SET_TAB', 0);
      this.$store.commit('legalModal/OPEN_MODAL');
    }
    await this.$store.dispatch('menu/setIndexActive', 0);
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue